import PanelInlineContent from "./panel-inline-content";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@babackapp/ui/components/toggle-group";
import {
  AlignCenterVertical,
  AlignEndVertical,
  AlignStartVertical,
} from "lucide-react";
import { useBlockPanelPropsContext } from "./panel-container";
import { useTranslation } from "react-i18next";

export default function PanelBlockAlignment() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.alignment || "left";

  const handleUpdate = (alignment: string) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      alignment,
    });
  };

  return (
    <PanelInlineContent
      title={t("editorBlocksLibrary.panel.alignment.title", "Alignment")}
    >
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (
            value &&
            (value === "left" || value === "center" || value === "right")
          ) {
            handleUpdate(value);
          }
        }}
      >
        <ToggleGroupItem value="left" aria-label="Toggle align left">
          <AlignStartVertical className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="center" aria-label="Toggle align center">
          <AlignCenterVertical className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="right" aria-label="Toggle align right">
          <AlignEndVertical className="h-4 w-4" />
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
